/* istanbul ignore file */
import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { CircularProgress } from '@material-ui/core';
import Slide from '@material-ui/core/Slide';
import useTranslation from '../../../hooks/use-translation';
import caveman from '../../../images/caveman.svg';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const styles = {
  cancelButton: {
    fontFamily: 'JioType-Medium',
    color: '#214796',
    fontSize: '16px',
    width: '10em',
    alignSelf: 'center',
    backgroundColor: '#F6f6f6',
    outline: 'none',
    height: '2em',
    border: 'none'
  },
  buttonDisabled: {
    textTransform: 'none',
    height: '2em',
    width: '10em',
    border: 'none',
    backgroundColor: '#93BED8',
    color: '#ffffff',
    fontSize: '1em',
    fontFamily: 'jioType-Medium',
    outline: 'none'
  },
  actionButton: {
    fontFamily: 'JioType-Medium',
    color: '#FFFFFF',
    fontSize: '16px',
    width: '10em',
    alignSelf: 'center',
    backgroundColor: '#214796',
    outline: 'none',
    height: '2em',
    border: 'none'

  }
};
const TryAgain = props => {
  const {
    open = false, handleDialogOk, handleCancel, errorMessage = ''
  } = props;
  const { t } = useTranslation();
  const [retryLoading, setRetryLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);

  const handleTryAgain = async () => {
    setRetryLoading(true);
    await handleDialogOk();
    setRetryLoading(false);
  };

  const handleCancelButton = () => {
    setCancelLoading(true);
    handleCancel();
    setCancelLoading(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="dialog-title"
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            marginLeft: '22px',
            marginRight: '22px',
            width: '28.125em',
            background: '#f6f6f6 0% 0% no-repeat padding-box',
            boxShadow: '16px 0px 24px #00000029',
            borderRadius: '0.625em'
          }
        }}
      >
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '1em'
        }}
        >
          <div style={{ height: '10em', width: '10em' }}>
            <img src={caveman} alt="" />
          </div>
        </div>
        <DialogContent>
          <DialogContentText style={{ textAlign: 'center', marginTop: '1em' }}>
            {errorMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'space-evenly' }}>
          <button style={cancelLoading ? styles.buttonDisabled : styles.cancelButton} onClick={handleCancelButton}>

            <span>
              {' '}
              {cancelLoading ? (
                <span className={styles.loader}>
                  <CircularProgress size={20} />
                  {' '}
                </span>
              ) : t('CANCEL')}
            </span>
          </button>
          <button style={retryLoading ? styles.buttonDisabled : styles.actionButton} onClick={handleTryAgain}>

            <span>
              {' '}
              {retryLoading ? (
                <span>
                  <CircularProgress size={20} />
                  {' '}
                </span>
              ) : t('RETRY')}
            </span>
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TryAgain;
